
import MicrophoneSlash1 from "../../../assets/filled/MicrophoneSlash1.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MicrophoneSlash1Icon({ className, dataTestid = "MicrophoneSlash1Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MicrophoneSlash1 data-testid={dataTestid} className={classes} {...rest} />
  );
}
